import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const selectRoot = ({ successOrder }: RootState) => successOrder;

export const selectSuccessOrder = createSelector(
    selectRoot,
    successOrder => successOrder,
);
